import { authAxios } from '@libraries/common/axios';

const caller = async (url: string, params: Object) => {
  const response = await authAxios.get(url, { params });
  const { body } = response.data;
  const { error, errorCode, errorMessage, result } = body;

  if (error) {
    throw { errorCode, errorMessage };
  }

  return result;
};

const fetcher = async (url: string, params: Object) => {
  const result = await caller(url, params);

  return result;
};

export { fetcher };
